import { axios } from '@/lib/axios';

import { AuthUser } from '@/features/auth';

export type LoginCredentialsDTO = {
  username: string;
  password: string;
};

export const loginWithEmailAndPassword = (data: LoginCredentialsDTO): Promise<AuthUser> => {
  return axios.post('/users/authenticate', data);
};
